import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { InputTextModule } from "primeng/inputtext";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { RadioButtonModule } from "primeng/radiobutton";
import { NgIf } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { PasswordModule } from "primeng/password";
import { Router } from "@angular/router";
import { ToastModule } from "primeng/toast";
import { FileUploadModule } from "primeng/fileupload";
import { MessageService } from "primeng/api";
import { EProductGroupType } from '../enums/EProductGroupType';
import { IProducts_P } from '../interfaces/IProducts';
import { ProductOrderComponent } from '../product-order/product-order.component';
import { EventS } from '../service/event.s';
import { AuthService } from "../service/auth.service";
import { AddOrderService } from "../service/add-order.service";
import { ProductsService } from "../service/products.service";
import { DataProviderService } from "../service/data-provider.service";
import { environment } from "../../environments/environment";
import { NotificationService } from "../service/notification.service";
import { CheckboxModule } from "primeng/checkbox";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ProductGroupService } from "../service/product-group.service";
import * as _ from 'lodash';

declare const $: any;

type MaybeUploadPath = | string | { uploadPath?: string | null } | Array<string | { uploadPath?: string | null }>;

@Component({
    selector: 'app-add-order',
    standalone: true,
    imports: [InputTextModule, ReactiveFormsModule, DropdownModule, RadioButtonModule, DialogModule, PasswordModule, ToastModule, FileUploadModule, NgIf, CheckboxModule, ProductOrderComponent, ProgressSpinnerModule, FormsModule],
    templateUrl: './add-order.component.html',
    styleUrls: ['./add-order.component.scss'],
    providers: [MessageService]
})
export class AddOrderComponent implements OnInit {
    visible: boolean = false;
    loading: boolean = false;
    addOrderForm: FormGroup | any;
    products: product[] = [];
    productGroups: any[] = [];
    productGroupsMap: { [_id: string]: any } = {};

    qualities: category[] = [];
    sheets: category[] = [];

    description: any;
    productGroupId: string = '';
    taxValue: any;
    taxName: any;
    productGroup: string = "";
    productGroupCategory: string = "";
    productImages: any[] = [];
    itemCount: number = 0;
    selectedProduct: product | undefined;
    showCdrModal: boolean = false;
    EProductGroupType = EProductGroupType;

    @ViewChild('productOrderComponent') productOrderComponents!: ProductOrderComponent;

    constructor(
        private fb: FormBuilder,
        private cd: ChangeDetectorRef,
        private ns: NotificationService,
        public authService: AuthService,
        private addOrderService: AddOrderService,
        private productsService: ProductsService,
        private productGroupService: ProductGroupService,
        private dataProviderService: DataProviderService,
        private router: Router,
        private eventCenterS: EventS
    ) {
        this.addOrderForm = this.fb.group({
            selectedProduct: ['', Validators.required],
            selectedQty: ['', Validators.required],
            width: [''],
            height: [''],
            quality: [''],
            sheet: [''],
            price: [''],
            jobName: ['', Validators.required],
            totalPrice: ['',],
            selectedCategory: '',
        });
        this.addOrderForm.get('price')?.disable();
        this.addOrderForm.get('totalPrice')?.disable();
    }

    onCartCountChange(count: number) {
        this.itemCount = count;
    }

    async ngOnInit() {
        this.showCdrModal = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (!this.dataProviderService.getDataForAddOrder().productGroupId) {
            await this.router.navigate(['/product']);
        } else {
            let result = this.dataProviderService.getDataForAddOrder();
            // console.log(result);
            // this.description = result.description;
            this.productGroupId = result.productGroupId;
            this.taxName = result.taxName;
            this.taxValue = result.taxValue;
            this.productGroup = result.groupName;
            this.productGroupCategory = result.productGroupCategory;
        }

        let findObj = <IProducts_P>{
            mpp_productGroup_objid: this.productGroupId,
            active: true
        };

        this.addOrderForm.get('selectedCategory')?.setValue(this.productGroupId);

        findObj.mpp_IsGstProduct_bl = !!this.authService.gUser?.usr_gstNumber_str;

        if (!this.authService.gUser?._id) findObj.mpp_IsGstProduct_bl = true;

        this.products = await this.productsService.query({
            find: findObj
        });

        this.productGroups = await this.productGroupService.query({
            select: { mpg_productGroupName_str: 1, mpg_productGroupCategory_str: 1 }
        });
        this.productGroupsMap = _.keyBy(this.productGroups, '_id');

        this.qualities = [
            { name: 'SOLVENT', code: 'SOLVENT' },
            { name: 'ECO', code: 'ECO' },
            { name: 'UV', code: 'UV' }
        ];
        this.sheets = [
            { name: '3MM', code: '3MM' },
            { name: '5MM', code: '5MM' }
        ];

        // Initialize Owl Carousel
        // this.initiateOwnCarousel();
        this.cd.detectChanges();
    }

    initiateOwlCarousel() {
        $('#owl-carousel-1').owlCarousel({
            loop: true,
            nav: false,
            margin: 10,
            autoplay: true,
            autoplayTimeout: 4000,
            slideTransition: 'linear',
            autoplayHoverPause: false,
            dots: false,
            responsiveClass: true,
            responsive: {
                0: { items: 1.5 },
                600: { items: 2.5 },
                999: { items: 2.5 },
                1030: { items: 1.5 },
                1130: { items: 1.5 },
                1280: { items: 1.5 },
                1400: { items: 2.5 },
                1700: { items: 2.5 },
                1920: { items: 2.5 }
            }
        });
    }

    destroyOwlCarousel() {
        const $carousel = $('#owl-carousel-1');
        if ($carousel.hasClass('owl-loaded')) {
            $carousel.trigger('destroy.owl.carousel');
            $carousel.removeClass('owl-carousel owl-loaded');
            $carousel.find('.owl-stage-outer').children().unwrap();
        }
    }

    refreshOwlCarousel() {
        const $carousel = $('#owl-carousel-1');
        $carousel.addClass('owl-carousel');
    }

    pickUploadPath(input: MaybeUploadPath): string {
        // If it's an array, use first entry
        if (Array.isArray(input)) {
            const first = input[0] as any;
            return this.pickUploadPath(first as MaybeUploadPath);
        }
        // If it's an object with uploadPath
        if (input && typeof input === 'object') {
            const maybe = (input as any).uploadPath;
            return typeof maybe === 'string' ? maybe : '';
        }
        // If it's a string already (direct path)
        if (typeof input === 'string') return input;
        return '';
    }

    async changeProducts() {
        this.resetForm();
        this.destroyOwlCarousel();
        this.productImages = [];
        this.description = '';
        let selectedCategories: product | undefined = this.products.find((element: product) => {
            return element._id == this.addOrderForm.get('selectedCategory')?.value;
        });
        selectedCategories?.mpp_productGroupImg_arr.forEach((item: any) => {
            let path = environment.FILE_URL + this.pickUploadPath(item);
            this.productImages.push(path);
        });
        let findObj = <any>{ mpp_productGroup_objid: this.addOrderForm.get('selectedCategory')?.value, active: true };

        if (this.authService.gUser?.usr_gstNumber_str) {
            findObj.mpp_IsGstProduct_bl = true;
        } else {
            findObj.$or = [{
                mpp_IsGstProduct_bl: <any>{
                    $exists: false,
                }
            }, {
                mpp_IsGstProduct_bl: <any>{
                    $in: [null, '']
                }
            }, {
                mpp_IsGstProduct_bl: false
            }];
        }

        if (!this.authService.gUser?._id) {
            findObj.mpp_IsGstProduct_bl = true;
            delete findObj.$or
        }

        this.products = await this.productsService.query({ find: findObj });

        // let selectedProductGroup = this.productGroupsMap[this.addOrderForm.get('selectedCategory')?.value];
        // this.dataProviderService.productGroupId = selectedProductGroup._id;

        this.productGroup = this.productGroupsMap[this.addOrderForm.get('selectedCategory')?.value]?.mpg_productGroupName_str;
        this.productGroupCategory = this.productGroupsMap[this.addOrderForm.get('selectedCategory')?.value]?.mpg_productGroupCategory_str;
        this.productGroupId = this.addOrderForm.get('selectedCategory')?.value;
        this.dataProviderService.productGroupId = this.productGroupId;
        this.cd.detectChanges();
    }


    resetForm() {
        this.addOrderForm.get('selectedProduct').setValue(null);
        this.addOrderForm.get('jobName').setValue(null);
        this.addOrderForm.get('selectedQty').setValue(null);
        this.addOrderForm.get('width').setValue(null);
        this.addOrderForm.get('height').setValue(null);
        this.addOrderForm.get('sheet').setValue(null);
        this.addOrderForm.get('quality').setValue(null);
        this.addOrderForm.get('price').setValue(null);
        this.addOrderForm.get('totalPrice').setValue(null);
    }

    async renderImagesAndDesc() {
        this.destroyOwlCarousel();
        this.productImages = [];
        let selectedProduct: product = <any>this.products.find((element: product) => {
            return element._id == this.addOrderForm.get('selectedProduct')?.value;
        });
        selectedProduct?.mpp_productGroupImg_arr.forEach((item: any) => {
            let path = environment.FILE_URL + this.pickUploadPath(item);
            this.productImages.push(path);
        });
        this.description = selectedProduct?.mpp_description_str;
        this.selectedProduct = selectedProduct;
        this.addOrderForm.get('price').setValue(this.selectedProduct.mpp_productPrice_num);
        this.addOrderForm.get('selectedQty').setValue(null);
        this.addOrderForm.get('height')?.setValue(null);
        this.addOrderForm.get('width')?.setValue(null);
        this.addOrderForm.get('sheet').setValue(null);
        this.addOrderForm.get('quality').setValue(null);
        this.addOrderForm.get('jobName').setValue(null);
        this.cd.detectChanges();

        this.refreshOwlCarousel();

        setTimeout(() => {
            this.initiateOwlCarousel();
        }, 100);
        this.refreshOwlCarousel();
        // this.addOrderForm.get('totalPrice')?.setValue(selectedProduct.mpp_productPrice_num);
    }

    onKeyDownPaymentAmount(event: KeyboardEvent) {
        const invalidKeys = ['e', 'E', '+', '-', '='];
        const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
        if (invalidKeys.includes(event.key) && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    }

    calculateTotalPrice() {
        let quantity = this.addOrderForm.get('selectedQty').value;
        let price = this.addOrderForm.get('price').value;
        let height = this.addOrderForm.get('height').value;
        let width = this.addOrderForm.get('width').value;

        const qty = Number(quantity);
        let totalPrice: number = 0;

        if (quantity && price && this.productGroupCategory === EProductGroupType.DISPLAY_ITEM_PCS && this.selectedProduct && this.selectedProduct._id) {
            totalPrice = Number(price) * qty;
        }
        if (quantity && height && width && price && this.selectedProduct && this.selectedProduct._id) {
            if (this.productGroupCategory === EProductGroupType.VINYL_SQ_FT
                || this.productGroupCategory === EProductGroupType.SPECIAL_MEDIA_SQ_FT
                || this.productGroupCategory === EProductGroupType.SHEET_BOARD_SQ_FT_OR_SQ_INCH) {
                totalPrice = (Number(price) * qty) * ((width || 1) * (height || 1));
            }

            if (this.productGroupCategory === EProductGroupType.BANNER_SQ_FT) {
                let quality = this.addOrderForm.get('quality').value;
                let sheet = this.addOrderForm.get('sheet').value;

                if (quality) {
                    if (quality === 'SOLVENT') price += this.selectedProduct.mpp_solvent_price_num || 0;
                    if (quality === 'ECO') price += this.selectedProduct.mpp_eco_price_num || 0;
                    if (quality === 'UV') price += this.selectedProduct.mpp_uv_price_num || 0;
                }
                if (sheet) {
                    if (sheet === '3MM') price += this.selectedProduct.mpp_3mm_price_num || 0;
                    if (sheet === '5MM') price += this.selectedProduct.mpp_5mm_price_num || 0;
                }

                totalPrice = (Number(price) * qty) * ((width || 1) * (height || 1));
            }
        }
        this.addOrderForm.get('totalPrice').setValue(totalPrice);
    }

    onHeightWidthBlur(field: 'height' | 'width') {
        const value = this.addOrderForm.get(field)?.value;

        if (value !== null && value !== undefined && value !== '') {
            this.addOrderForm.get(field)?.setValue(
                +this.roundHeightWidth(+value).toFixed(2),
                { emitEvent: false }
            );
        }
    }

    roundHeightWidth(value: number): number {
        return Math.ceil(value * 4) / 4;
    }

    async onSubmit() {
        if (!this.authService?.gUser?._id) return this.eventCenterS.openLoginDialog.next(true);
        if (this.addOrderForm.valid) {
            if (this.itemCount === 1) {
                this.ns.showError("Please Checkout the existing order");
                return;
            }
            let formData = this.addOrderForm.getRawValue();

            if (!formData.height && this.productGroupCategory !== EProductGroupType.DISPLAY_ITEM_PCS) return this.ns.showError("Please enter height.");
            if (!formData.width && this.productGroupCategory !== EProductGroupType.DISPLAY_ITEM_PCS) return this.ns.showError("Please enter width.");

            const orderForm = {
                product_objid: this.addOrderForm.get('selectedProduct')?.value,
                productGroup_objid: this.productGroupId, // product group id
                productGroup: this.productGroup,
                productGroupCategory: this.productGroupCategory,
                jobName: this.addOrderForm.get('jobName')?.value,
                width: this.addOrderForm.get('width')?.value,
                height: this.addOrderForm.get('height')?.value,
                sheet: formData.sheet,
                quality: formData.quality,
                price: formData.price,
                quantity: formData.selectedQty,
                totalPrice: formData.totalPrice,
                user_objid: this.authService.gUser?._id,
            };
            let res = await this.addOrderService.post(orderForm);
            if (res) {
                this.ns.showSuccess(`Item added successfully to your cart`);
                this.eventCenterS.loadAddToCard.next(true);
                this.eventCenterS.loadAddToCardProducts.next(true);
                // this.resetForm();
            }
        } else {
            if (this.addOrderForm.invalid) {
                this.ns.showError(`Please fill details`);
            } else {
                this.ns.showError(`Something Went Wrong`);
            }
        }
    }
}


interface product {
    name: string;
    _id: string;
    mpp_IsGstProduct_bl: boolean;
    mpp_IsheightWidth_bl: boolean;
    mpp_productPrice_num: number;
    mpp_productGroupImg_arr: Array<any>;
    mpp_description_str: string;
    mpp_solvent_price_num: number;
    mpp_eco_price_num: number;
    mpp_uv_price_num: number;
    mpp_3mm_price_num: number;
    mpp_5mm_price_num: number;
}

interface category {
    name: string;
    code: string;
}
